export var replaceAWithHref = function (str) {
    var regex = /\b[\w.-]+\.[a-z]{2,}(?:\/\w+)*\/project\/[\w-]+\b/g;
    return str.replace(regex, '');
};
export var extractProjectId = function (str) {
    var regex = /\b[\w.-]+\.(com|net|org|ru|[a-z]{2,})(?:\/\w+)*\/project\/([\w-]+)\b/i;
    var match = str.match(regex);
    return match ? match[2] : "";
};
//# sourceMappingURL=replaceHiddenProjectLink.js.mapexport var replaceAWithHref = function (str) {
    var regex = /\b[\w.-]+\.[a-z]{2,}(?:\/\w+)*\/project\/[\w-]+\b/g;
    return str.replace(regex, '');
};
export var extractProjectId = function (str) {
    var regex = /\b[\w.-]+\.(com|net|org|ru|[a-z]{2,})(?:\/\w+)*\/project\/([\w-]+)\b/i;
    var match = str.match(regex);
    return match ? match[2] : "";
};
//# sourceMappingURL=replaceHiddenProjectLink.js.map